module.exports = __webpack_public_path__ + "static/media/charity-fostercare.c8e36b58.svg";